/**
  * @class meleMap_dot
  * @description
  *
  * # Purpose
  * Implaments DOT shape
  *
  * # Use
  *
  * # Implementation notes
  *
  */

import meleMap_shape from '../meleMap_shape.js'
const melemap_lib = require('../meleMap_lib.js')
const DOT_RADIUS = 1

export default class meleMap_dot extends meleMap_shape {
  static shape() { return 'D' }

  redrawShape() {
    if(this._points.length<1) { return this.deleteShape() }

    if(this._shape) {
      this._shape.setLatLng(this._points[0])
    }else {
      this._shape = L.circle(this._points[0], { radius: DOT_RADIUS, pane: this._props.pane || melemap_lib.DEFAULT_PANE }).addTo(this._map)
    }

    this.configureShape()
  }

  calculateCenter() {
    this._center = this._points.length>0 ? this._points[0] : ''
    return this._center
  }

  shape() {
    return melemap_lib.point2geohash(this._points[0])
  }

  addPoint(point) {
    this._points = [point]
    delete this._center
    this.redrawShape()
    this.redrawMarker()
  }

  guide(point) {
  }

  // returns bounds of the shape; special fix for circle
  bounds() {
    let bounds = null
    try{
      this._shape._project()
      bounds = this._shape.getBounds()
    }catch(e) {}
    return bounds
  }
} // class meleMap_dot
